import { useAnalytics } from './useAnalytics';
import { useCallback } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { getCookie, isMobileWeb } from 'stash/utils';
import { getStoredInstrumentationAttributions } from '../utils/attribution.js';

const ATTRIBUTION_EVENTS = {
	BUY_SETUP_SUCCEEDED: 'BuySetup_Succeeded',
	AI_CHAT_SUBMITTED: 'AiChat_Submitted',
	DEPOSIT_SETUP_SUCCEEDED: 'DepositSetup_Succeeded',
};

const EVENT_VERSIONS = {
	[ATTRIBUTION_EVENTS.BUY_SETUP_SUCCEEDED]: [1],
	[ATTRIBUTION_EVENTS.AI_CHAT_SUBMITTED]: [1],
	[ATTRIBUTION_EVENTS.DEPOSIT_SETUP_SUCCEEDED]: [2],
};

const enrichEventProperties = (event, properties, context) => {
	const eventVersion = context?.protocols?.event_version;
	const isAttributionEvent = Object.values(ATTRIBUTION_EVENTS).includes(event);
	const supportedVersions = EVENT_VERSIONS[event];

	if (isAttributionEvent && supportedVersions?.includes(eventVersion)) {
		return {
			...properties,
			...getStoredInstrumentationAttributions(),
		};
	}

	return properties;
};

const createWebViewContext = () => {
	return {
		originatingApp: getCookie('nativePlatform') || 'web',
		originatingAppVersion: getCookie('nativeAppVersion'),
		originatingAppId: getCookie('nativeAppID'),
	};
};

// This hook expects events from 'src/product-events'. For legacy events, continue to use the useAnalytics directly.
export const useTrack = () => {
	const analytics = useAnalytics();

	return useCallback(
		({ event, properties, context, metric }) => {
			datadogRum.addAction(metric, properties);

			const enrichedProperties = enrichEventProperties(event, properties, context);

			return analytics.track(event, enrichedProperties, {
				context: {
					...context,
					stash_clean: true,
					isMobileWeb: isMobileWeb(),
					...createWebViewContext(),
				},
			});
		},
		[analytics]
	);
};
